import { init } from './init';

type GAEvent = {
  eventCategory: string;
  eventAction: string;
  eventLabel?: string;
  eventValue?: number;
};

export interface GAWindow extends Window {
  ga?: Function;
}

export function sendPageview(page: string) {
  ga('set', 'page', page);
  ga('send', 'pageview');
}

export function sendEvent(event: GAEvent) {
  ga('send', 'event', event);
}

export function setUserId(userId: string) {
  ga('set', 'userId', userId);
}

export function setEmployee(isEmployee: boolean) {
  ga('set', 'dimension1', isEmployee ? 'internal' : 'external');
}

export function setAccess(hasAccess: boolean) {
  ga('set', 'dimension3', hasAccess ? 'Yes' : 'No');
}

export function setLastVisitedArtist(artistId: string) {
  ga('set', 'dimension4', artistId);
}

const _window: GAWindow = window;

function ga(...args: any[]) {
  if (_window.ga) {
    _window.ga(...args);
  }
}

if (process.env.NODE_ENV === 'production') {
  init();
  ga('create', getGoogleAnalyticsId(), 'auto', { siteSpeedSampleRate: 10 });
  ga('set', 'anonymizeIp', true);
  ga('require', 'displayfeatures');
  ga('set', 'dimension2', 'isNotFive'); // legacy dimension
}

function getGoogleAnalyticsId(): string | undefined {
  switch (window.location.hostname) {
    case 'artists.spotify.com':
      return 'UA-5784146-42';
    case 'artists-staging.spotify.com':
      return 'UA-5784146-41';
    default:
      return undefined;
  }
}
